require('./bootstrap');
require('./toast1');

import './components/FormsTable';